<template>
  <v-app>
    <v-main>
      <router-view name="header"/>

      <router-view/>

      <router-view name="footer"/>
      <snackbar/>
    </v-main>
  </v-app>
</template>

<script>
import Snackbar from "./components/Snackbar";
export default {
  name: 'App',
  components: {Snackbar},
  metaInfo: {
    title: 'Exwebs',
    titleTemplate: 'Admin Dashboard | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
};
</script>

<style lang="scss">
/*For Input Field Right Align*/
.right-align-text input {
  text-align: right;
}
</style>
